/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { registerFromDeviceRequestRequestSchema } from "./registerFromDeviceRequestRequestSchema.ts";
import { tokensSchema } from "./tokensSchema.ts";

export const deviceAuthRegisterCreateStatus200Schema = tokensSchema.describe("Сериализатор вывода токена - для документации.");

export const deviceAuthRegisterCreateStatus400Schema = errorResponseSchema;

export const deviceAuthRegisterCreateStatus403Schema = errorResponseSchema;

export const deviceAuthRegisterCreateStatus404Schema = errorResponseSchema;

export const deviceAuthRegisterCreateResponseSchema = z.union([
	deviceAuthRegisterCreateStatus200Schema,
	deviceAuthRegisterCreateStatus400Schema,
	deviceAuthRegisterCreateStatus403Schema,
	deviceAuthRegisterCreateStatus404Schema,
]);

export const deviceAuthRegisterCreateDataSchemaJson = registerFromDeviceRequestRequestSchema.describe("Сериализатор регистрации гостя с киоска.");

export const deviceAuthRegisterCreateDataSchemaXml = registerFromDeviceRequestRequestSchema.describe("Сериализатор регистрации гостя с киоска.");

export const deviceAuthRegisterCreateDataSchema = z.union([deviceAuthRegisterCreateDataSchemaJson, deviceAuthRegisterCreateDataSchemaXml]);
